import type { MarketVariants } from '@/lib/i18n'

export type Slide07Copy = {
  title: string
  /** Body sentence. Must contain the sentinel "{trigger}" exactly once, it
   *  marks the phrase that renders as the dotted-underline slideover trigger. */
  body: string
  triggerText: string
  sources: string

  /** Small eyebrow above the panel title. */
  panelEyebrow: string
  panelTitle: string
  panelIntro: string
  panelBeat1Label: string
  panelBeat1Body: string
  panelBeat2Label: string
  panelBeat2Body: string
  panelBeat3Label: string
  panelBeat3Body: string
  panelBeat4Label: string
  panelBeat4Body: string
  panelBeat5Label: string
  panelBeat5Body: string
  panelClose: string
}

export const copy: MarketVariants<Slide07Copy> = {
  US: {
    title: 'Because it works.',
    body: "Scams now take in more money than the global drug trade. This isn't petty crime. It's {trigger}, and growing faster than almost any industry on earth.",
    triggerText: 'organized, professional',
    sources: 'Annual revenue, worldwide. Sources: Global Anti-Scam Alliance, FTC, Cifas',

    panelEyebrow: 'Go deeper',
    panelTitle: 'Inside a scam operation',
    panelIntro:
      "Today's scam operations are bigger, more coordinated, and more complex than most people realize.",

    panelBeat1Label: 'They recruit',
    panelBeat1Body:
      'Job listings go up on Telegram and WeChat. Language fluency and keyboard speed are prerequisites. Pay is commission-based.',

    panelBeat2Label: 'They train',
    panelBeat2Body:
      'New hires get onboarding manuals and role-play practice. Senior scammers mentor juniors and review their calls.',

    panelBeat3Label: 'They script',
    panelBeat3Body:
      'Branching scripts cover every play: bank fraud, tech support, romance, investment. Lines are A/B tested for what converts.',

    panelBeat4Label: 'They clock in',
    panelBeat4Body:
      "Shift schedules are built around target markets' business hours. Daily targets, performance reviews, and leaderboards are common.",

    panelBeat5Label: 'They scale',
    panelBeat5Body:
      'Some operations run compounds in Southeast Asia housing thousands of workers, often under conditions of forced labor and human trafficking.',

    panelClose: 'Close',
  },
  // QA: the FTC here is a data citation, not reporting advice, so it stays.
  ar: {
    title: 'لأنه ينجح.',
    body: 'يجني الاحتيال اليوم أموالاً تفوق ما تجنيه تجارة المخدرات العالمية. هذه ليست جرائم صغيرة، بل صناعة {trigger}، تنمو بوتيرة أسرع من أي صناعة أخرى على وجه الأرض تقريباً.',
    triggerText: 'منظّمة واحترافية',
    sources:
      'الإيرادات السنوية حول العالم. المصادر: التحالف العالمي لمكافحة الاحتيال (GASA)، لجنة التجارة الفيدرالية الأمريكية (FTC)، Cifas',

    panelEyebrow: 'تعمّق أكثر',
    panelTitle: 'داخل عملية احتيال',
    panelIntro: 'عمليات الاحتيال اليوم أكبر وأكثر تنظيماً وتعقيداً مما يتصوّر معظم الناس.',

    panelBeat1Label: 'يوظّفون',
    panelBeat1Body:
      'تُنشر إعلانات الوظائف على تيليجرام ووي تشات. إتقان اللغة وسرعة الكتابة شرطان أساسيان. والأجر يعتمد على العمولة.',

    panelBeat2Label: 'يدرّبون',
    panelBeat2Body:
      'يحصل الموظفون الجدد على أدلة تدريبية وتمارين تمثيل الأدوار. ويشرف كبار المحتالين على المبتدئين ويراجعون مكالماتهم.',

    panelBeat3Label: 'يكتبون النصوص',
    panelBeat3Body:
      'نصوص متفرّعة تغطي كل سيناريو: احتيال البنوك، والدعم الفني، والعلاقات العاطفية، والاستثمار. وتُختبر العبارات لمعرفة أيها يحقق نتائج أفضل.',

    panelBeat4Label: 'يعملون بنظام الورديات',
    panelBeat4Body:
      'تُبنى جداول الورديات حول ساعات العمل في الأسواق المستهدفة. والأهداف اليومية وتقييمات الأداء ولوحات المتصدرين أمور شائعة.',

    panelBeat5Label: 'يتوسّعون',
    panelBeat5Body:
      'تدير بعض العمليات مجمّعات في جنوب شرق آسيا تضم آلاف العاملين، غالباً في ظروف من العمل القسري والاتجار بالبشر.',

    panelClose: 'إغلاق',
  },
}
